import React from "react";
import ButtonAction from "./ButtonAction";
import isolation from "../../../../assets/images/Event-2025/Isolation_mode.png";
import iconFooter from "../../../../assets/images/Event-2025/icon-bg-footer.svg";
import styled from "styled-components";

export default function FooterDetail({
  contentBtn = "Take Prize",
  action,
  isActiveButton = false,
}) {
  return (
    <Container Isolation={isolation}>
      <ButtonAction
        contentBtn={contentBtn}
        action={action}
        isActiveButton={isActiveButton}
      />
      <div className="bg-iso"></div>
      <div className="footer-page-event">
        <img src={iconFooter} alt="" className="bg-footer" />
      </div>
    </Container>
  );
}

const Container = styled.div`
  height: 80px;
  position: relative;
  width: 100%;
  background-color: #217efd;
  z-index: 2;

  .bg-iso {
    background-image: url(${(props) => props.Isolation});
    width: 100%;
    height: 165px;
    background-position: center;
    background-size: cover;
    position: absolute;
    top: -150px;
    z-index: 3;
  }

  .footer-page-event {
    width: 100%;
    height: auto;
    overflow: hidden;
    width: 100%;
  }

  .bg-footer {
    position: absolute;
    z-index: 9;
    top: -70px;
    height: 205px;
    pointer-events: none;
    width: 100%;
    object-fit: cover;
  }

  @media (max-width: 576px) {
    height: auto;
    .bg-iso {
      height: 130px;
      top: -125px;
    }

    .bg-btn {
      max-width: 280px;
    }

    .content-btn-event {
      font-size: 18px;
    }
  }

  @media (min-width: 1400px) {
    .bg-iso {
      height: 210px;
      top: -164px;
    }

    .bg-footer {
      height: 290px;
    }
  }
`;
